import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

/**
 * Injection contents for pickers, filtered to substances the user may choose
 * (`available_injection_substances`).
 */
async function getInjectionContents() {
    const [contentsResult, substancesResult] = await Promise.all([
        supabaseClient.from("injection_contents").select("*").throwOnError(),
        supabaseClient.from("available_injection_substances").select("injection_substance").throwOnError(),
    ]);

    const allowed = new Set((substancesResult.data ?? []).map((row) => row.injection_substance));
    return (contentsResult.data ?? []).filter((row) => allowed.has(row.injection_substance));
}

export const injection_contents_key = ["injection-contents", "available"];

export const injectionContentsQueryOptions = () => {
    return queryOptions({
        queryKey: injection_contents_key,
        queryFn: async () => getInjectionContents(),
        staleTime: 30_000,
    });
};

export function useInjectionContentsQuery() {
    return useQuery(injectionContentsQueryOptions());
}
